<div class="mb-3">
  <label class="form-label fw-semibold text-label">
    Geographic Node
  </label>

  <select class="form-select custom-select" [value]="value || ''" (change)="onSelectChange($event)">
    <option value="" disabled selected>Select a geographic node...</option>
    @for(opt of options; track opt.id) {
    <option [value]="opt.id">
      {{ opt.label }}
    </option>
    }
  </select>

  <div class="form-text text-muted mt-1">
    Determines which operational channels this user can access.
  </div>
</div>